import { useState } from "react";
import { ComparativeInputCard } from "./components/ComparativeInputCard";
import { ComparativeResponse } from "./components/ComparativeResponse";
import type { ComparativeResultsType } from "./calculadora-comparativa";

export default function CalculadoraComparativa() {
  const [results, setResults] = useState<ComparativeResultsType | null>(null);

  return (
    <>
      <ComparativeInputCard setResults={setResults} />
      {results && <ComparativeResponse results={results} />}
    </>
  );
}